import styled from 'styled-components';

export const PieChartWrapper = styled.div`
  margin-top: 20px;
  border-top: 1px solid #ecf0f1;
  width: 400px;
`;
